import { SuperBannerCMSConfiguration, SuperBannerCMSConfigurationType } from "./SuperBannerCMSConfiguration";
import { SuperBannerItem } from "..";

export type SuperBannerConfigurationType = SuperBannerCMSConfigurationType & {
    SuperBannerItems: SuperBannerItem[]
};

export class SuperBannerConfiguration extends SuperBannerCMSConfiguration {
    public SuperBannerItems: SuperBannerItem[] = [];

    constructor(source: SuperBannerConfigurationType) {
        super(source);

        /* istanbul ignore next */
        if (source.SuperBannerItems) {
            for (let index = 0; index < source.SuperBannerItems.length; index++) {
                this.SuperBannerItems.push(new SuperBannerItem(source.SuperBannerItems[index]));
            }
        }
    }
}